import { Box, Typography, Button, Container, Grid, MenuItem, Select } from "@mui/material";
import { Helmet } from "react-helmet";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import USFlag from "../images/flags/uk-flag-icon.png";
import FranceFlag from "../images/flags/french-flag-icon.png";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

export default function LandingDesktop() {
  const { translate, language, setLanguage } = useContext(LanguageContext);
  const handleLanguageChange = (e) => setLanguage(e.target.value);
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{translate("HeroTitleFull")}</title>
        <meta name="description" content={translate("HeroMetaDescription")} />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Box
        sx={{
          bgcolor: theme.palette.background.default,
          color: "text.primary",
          py: { xs: 6, md: 12 },
          px: { xs: 2, md: 0 },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={6}
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                fontWeight={700}
                color="text.primary"
                sx={{ mb: 2, lineHeight: 1.2 }}
              >
                {translate("HeroTitlePart1")} <br />
                {translate("HeroTitlePart2")}{" "}
                <Box component="span" color="#D0BFFF">
                  {translate("HeroHighlight")}
                </Box>
              </Typography>
              <Typography
                variant="subtitle1"
                color="text.secondary"
                sx={{ mb: 4 }}
              >
                {translate("HeroSubtitle")}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "stretch", sm: "center" },
                  gap: 2,
                  mt: 4,
                }}
              >
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => navigate("/login")}
                  sx={{
                    textTransform: "none",
                    minWidth: { sm: 220 },
                    px: 4,
                    py: 1.5,
                    borderRadius: 4,
                    fontWeight: 600,
                  }}
                >
                  {translate("HeroPrimaryCta")}
                </Button>
              </Box>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 2 }}
              >
                {translate("HeroPrimaryCtaHelper")}
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Feature bars */}
      <Box sx={{ py: 6, px: { xs: 2, md: 0 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            {[
              { textKey: "FeatureZeroCost" },
              { textKey: "FeatureEase" },
              { textKey: "FeaturePremiumValue" },
            ].map((bar) => (
              <Grid key={bar.textKey} item xs={12} md={4}>
                <Box
                  sx={{
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    p: 4,
                    borderRadius: 2,
                    textAlign: "center",
                    fontWeight: 600,
                  }}
                >
                  {translate(bar.textKey)}
                </Box>
              </Grid>
            ))}
          </Grid>

          <div
            style={{
              width: "100%",
              paddingTop: "20px",
            }}
          >
            <div style={{ width: "150px" }}>
              <Select
                value={language}
                onChange={handleLanguageChange}
                displayEmpty
                IconComponent={() => null}
                sx={{
                  height: 30,
                  minWidth: 50,
                  pl: 1,
                  pr: 0,
                  bgcolor: theme.palette.background.paper,
                  color: theme.palette.text.primary,

                  "&:before, &:after": { border: 0 },
                  // centre parfaitement la « select box »
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "& .MuiSelect-select": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    p: 0,
                  },
                }}
              >
                {/** chaque item centré lui aussi **/}
                <MenuItem
                  value="en"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    py: 0.5,
                  }}
                >
                  <img src={USFlag} alt="" width={20} />
                  English
                </MenuItem>
                <MenuItem
                  value="fr"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    py: 0.5,
                  }}
                >
                  <img src={FranceFlag} alt="" width={20} />
                  Français
                </MenuItem>
              </Select>
            </div>
          </div>
        </Container>
      </Box>
    </>
  );
}
